import { c as _c } from "react/compiler-runtime";
import { pickImage, ImageTier } from "@/utils/imageVariant";
import useRealEstateDetail from "@/hooks/QueryHooks/useRealEstateDetail";
import RenderImage from "@/components/atoms/RenderImage";
import { Button } from "@/components/ui/button";
import { OutputNodeAtom } from "@/types/real-estate";
import { useDialogDetails } from "@/components/modules/realEstateDetail/dialogComponents/DialogProvider";
import { EleiloesSubType } from "@/types/real-estate-features";
import { Badge } from "@/components/ui/badge";
import { ShareDrawer } from "@/components/modules/realEstateDetail/RealEstateDetail/components/share-drawer";
import CardFavorite from "@/components/cardElements/FavoritesModalGroup/CardFavorite";
import Price from "@/components/atoms/Price";
type Props = {
  node: OutputNodeAtom;
};
export default function MapAtomPopupContent(t0) {
  const $ = _c(58);
  const {
    node
  } = t0;
  const {
    handleOpenDialog
  } = useDialogDetails();
  let t1;
  if ($[0] !== node.realEstateId) {
    t1 = {
      realEstateId: node.realEstateId
    };
    $[0] = node.realEstateId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const realEstateDetail = useRealEstateDetail(t1);
  const data = realEstateDetail.data?.data.realEstate;
  const user = realEstateDetail.data?.data.user;
  const featuresData = realEstateDetail.data?.data.features;
  const analytics = realEstateDetail.data?.data.analytics;
  const realEstateType = EleiloesSubType[featuresData?.find(_temp)?.featureValue];
  const isFavorite = realEstateDetail?.data?.data?.isFavorite;
  if (!realEstateDetail.data) {
    return;
  }
  let t2;
  if ($[2] !== data || $[3] !== user?.image) {
    t2 = pickImage(data, ImageTier.Small) || user?.image;
    $[2] = data;
    $[3] = user?.image;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = data?.title;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="relative h-40 w-full"><RenderImage src={t2} alt={t3} fill={true} className="object-cover" data-sentry-element="RenderImage" data-sentry-source-file="MapAtomPopupContent.tsx" /></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = data?.title;
  let t6;
  if ($[8] !== t5) {
    t6 = <h3 className="text-lg font-bold text-foreground truncate">{t5}</h3>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== data.agency) {
    t7 = <p className="text-sm text-muted-foreground">{data.agency}</p>;
    $[10] = data.agency;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== data.businessType || $[13] !== data.lastBidPrice || $[14] !== data.minPrice || $[15] !== data.rentPrice || $[16] !== data.salePrice) {
    t8 = <Price businessType={data.businessType} salePrice={data.salePrice} lastBidPrice={data.lastBidPrice} minPrice={data.minPrice} rentPrice={data.rentPrice} data-sentry-element="Price" data-sentry-source-file="MapAtomPopupContent.tsx" />;
    $[12] = data.businessType;
    $[13] = data.lastBidPrice;
    $[14] = data.minPrice;
    $[15] = data.rentPrice;
    $[16] = data.salePrice;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = data?.slug;
  const t10 = data?.title;
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <ShareDrawer className="w-5 h-5 text-foreground" realEstateId={t9} title={t10} data-sentry-element="ShareDrawer" data-sentry-source-file="MapAtomPopupContent.tsx" />;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = data?.slug;
  const t13 = data?.id;
  let t14;
  if ($[21] !== isFavorite || $[22] !== t12 || $[23] !== t13) {
    t14 = <CardFavorite realEstateSlug={t12} realEstateId={t13} favorite={isFavorite} className="text-transparent" data-sentry-element="CardFavorite" data-sentry-source-file="MapAtomPopupContent.tsx" />;
    $[21] = isFavorite;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t14) {
    t15 = <div className="flex gap-3 items-center">{t11}{t14}</div>;
    $[25] = t11;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15 || $[29] !== t8) {
    t16 = <div className="flex w-full justify-between items-center pt-2">{t8}{t15}</div>;
    $[28] = t15;
    $[29] = t8;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t6 || $[33] !== t7) {
    t17 = <div className="p-2">{t6}{t7}{t16}</div>;
    $[31] = t16;
    $[32] = t6;
    $[33] = t7;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== realEstateType) {
    t18 = realEstateType && <Badge size="md" variant="muted" className="rounded-full cursor-default"><span>{realEstateType}</span></Badge>;
    $[35] = realEstateType;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== featuresData) {
    t19 = featuresData?.find(_temp2)?.featureValue && <Badge size="md" variant="muted" className="rounded-full cursor-default"><span>{featuresData?.find(_temp3)?.featureValue}</span></Badge>;
    $[37] = featuresData;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const t20 = analytics?.viewCount;
  let t21;
  if ($[39] !== t20) {
    t21 = <Badge className="rounded-full cursor-default hover:bg-transparent" variant="outline" size="md" data-sentry-element="Badge" data-sentry-source-file="MapAtomPopupContent.tsx">Visualizações <span>{t20}</span></Badge>;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const t22 = analytics?.uniqueViewCount;
  let t23;
  if ($[41] !== t22) {
    t23 = <Badge className="rounded-full cursor-default hover:bg-transparent" variant="outline" size="md" data-sentry-element="Badge" data-sentry-source-file="MapAtomPopupContent.tsx">Visitantes <span>{t22}</span></Badge>;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t18 || $[44] !== t19 || $[45] !== t21 || $[46] !== t23) {
    t24 = <div className="flex flex-wrap gap-2 items-center">{t18}{t19}{t21}{t23}</div>;
    $[43] = t18;
    $[44] = t19;
    $[45] = t21;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== data.slug || $[49] !== handleOpenDialog) {
    t25 = <div className="pt-4"><Button variant="simpleDark" onClick={() => handleOpenDialog(data.slug)} className="w-full" data-sentry-element="Button" data-sentry-source-file="MapAtomPopupContent.tsx">Ver Detalhes</Button></div>;
    $[48] = data.slug;
    $[49] = handleOpenDialog;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t24 || $[52] !== t25) {
    t26 = <div className="px-2 pb-2">{t24}{t25}</div>;
    $[51] = t24;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t17 || $[55] !== t26 || $[56] !== t4) {
    t27 = <div className="w-[350px]" data-sentry-component="MapAtomPopupContent" data-sentry-source-file="MapAtomPopupContent.tsx">{t4}{t17}{t26}</div>;
    $[54] = t17;
    $[55] = t26;
    $[56] = t4;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  return t27;
}
function _temp3(feature_0) {
  return feature_0.featureKey === "num_rooms";
}
function _temp2(feature_1) {
  return feature_1.featureKey === "num_rooms";
}
function _temp(feature) {
  return feature.featureKey === "real_estate_type";
}